import { AxiosError, AxiosResponse } from "axios";
import {
  IBillingProfileListModel,
  IBillingProfileModel,
} from "../models/billingProfile";
import { IGetListRequest, IResponse, IServerError } from "../models/common";

import { IDropDownListResponse } from "../models/common/IDropDownListResponse";
import http from "../common/http-commons";

const API_BASE_RESOURCE_URL = "/v1/billing-profile/";

export const BillingProfileService = {
  getList: async (
    params: IGetListRequest,
  ): Promise<IBillingProfileListModel | IServerError | IResponse> => {
    const response: AxiosResponse<IBillingProfileListModel> =
      await http.get<IBillingProfileListModel>(
        `/v1/billing-profile/?order_by=${params.order_by}&order_direction=${params.order_direction}&page=${params.page}&size=${params.size}&search_query=${params.search_query}`,
      );

    if (response.status === 200) {
      return response.data;
    } else if (response.status === 400) {
      return {
        status: false,
        message: "Bad Request.",
        error: true,
      };
    } else if (response.status === 500) {
      return {
        status: false,
        message: "Something went wrong.",
        error: true,
      };
    }

    return {
      status: false,
      message: "Something went wrong please try again later.",
    };
  },

  delBillingProfile: async (
    delPayload: any,
  ): Promise<string | IServerError | IResponse> => {
    // return new Promise(resolve => setTimeout(() => resolve("Flex Field has been deleted successfully"), 1000));
    try {
      const response: AxiosResponse<string> = await http.delete<string>(
        `/v1/billing-profile/${delPayload.billingProfileId}/`,
      );

      if (response.status === 200) {
        return "Employee has been deleted successfully";
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        delPayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },

  create: async (requestPayload: any): Promise<any> => {
    if (requestPayload.id) {
      const response: AxiosResponse<IBillingProfileModel> =
        await http.put<IBillingProfileModel>(
          `${API_BASE_RESOURCE_URL}${requestPayload.id}/`,
          requestPayload,
        );

      if (response.status === 200)
        return {
          success: true,
          message: "Success",
          data: response.data,
        };
      if (response.status === 400)
        return { success: false, data: response.data };

      return {
        success: false,
        message: "Something went wrong please try again later.",
      };
    }

    const response: AxiosResponse<IBillingProfileModel> =
      await http.post<IBillingProfileModel>(
        API_BASE_RESOURCE_URL,
        requestPayload,
      );

    if (response.status === 201)
      return {
        success: true,
        message: "Success",
        data: response.data,
      };

    return { success: false, data: response.data };
  },
  // getById: async (
  //   id: string | undefined
  // ): Promise<IDataModelResponsePayload<IBillingProfileModel> | null> => {

  //   if (!id) return null;
  //   const response: AxiosResponse<IBillingProfileModel> =
  //     await http.get<IBillingProfileModel>(`${API_BASE_RESOURCE_URL}${id}/`);

  //   if (response.status === 200) return { success: true, data: response.data };

  //   return { success: false, data: response.data };
  // },
  getDropDownList: async (): Promise<
    IDropDownListResponse[] | IServerError | IResponse
  > => {
    const response: AxiosResponse<IDropDownListResponse[]> = await http.get<
      IDropDownListResponse[]
    >("/v1/billing-profile/ddl-list");

    if (response.status === 200) {
      return response.data;
    }

    return {
      status: false,
      message: "Something went wrong please try again later.",
    };
  },
  getById: async (
    id: string | undefined,
    navigateToLogout: (path: string) => void,
  ): Promise<any | IServerError | IResponse | null> => {
    if (!id) return null;
    try {
      const response: AxiosResponse<IBillingProfileModel> =
        await http.get<IBillingProfileModel>(`/v1/billing-profile/${id}/`);

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  getBillingProfileDDL: async (): Promise<
    any | IServerError | IResponse | null
  > => {
    const response: AxiosResponse<any[]> = await http.get<any[]>(
      `/v1/billing-profile/ddl-list`,
    );
    if (response.status === 200) {
      return response.data;
    }

    return {
      status: false,
      message: "Something went wrong please try again later.",
    };
  },
};
